import { LOADER_STATUS, UPLOAD_HISTORY_TABLE_DATA, PREPARE_TABLE_DATA } from "./constants";

export const initialState = {
  loaderStatus: false,
  uploadHistoryTableData: [],
  prepareData: {},
};

const gstr9CNewPrepareReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case UPLOAD_HISTORY_TABLE_DATA:
      return {
        ...state,
        uploadHistoryTableData: action.uploadHistoryTableData,
      };
    case PREPARE_TABLE_DATA:
      return {
        ...state,
        prepareData: action.prepareData,
      };

    default:
      return state;
  }
};

export default gstr9CNewPrepareReducer;
